<template>
  <div class="pa-2">
      <v-card elevation="0" class="mx-auto my-3" max-width="800">
          <h3>نظام المساعدات المركزي</h3>
          <p>يرجى العلم بان الطلبات حاليا فقط لفئة البدون واي طلب من جنسيات أخرى سيتم الغاءه</p>
      </v-card>
    <v-card class="mx-auto my-3" max-width="800" tile>
      <v-list>
        <v-list-item v-for="item in helpRequestForms" :key="item.id" :to="`/submithelprequest/${item.id}`">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "HelpRequest",

  //********************** */
  components: {},

  //********************** */
  data: () => ({}),

  //********************** */
  computed: {
    ...mapGetters("Catalog", {
      helpRequestForms: "helpRequestForms",
    }),
  },

  //********************** */
  methods: {
    loadHelpRequestForms: async function () {
      await this.$store.dispatch("Catalog/loadHelpRequestForms");
    },
  },

  //*********************** */
  async mounted() {
    await this.loadHelpRequestForms();
  },
};
</script>

<style>
</style>